export default __webpack_public_path__ + "static/media/design_right.1832f7bd.png";